import * as apicall from "../components/Apicall";

const qs = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  const search = new URLSearchParams(clean).toString();
  return search ? `?${search}` : "";
};

/* ---------------------------------------------------------------- *
 *  Items & categories
 * ---------------------------------------------------------------- */
export const getItems = (filters = {}) => apicall.get(`inventory/items${qs(filters)}`);
export const getItem = (id) => apicall.get(`inventory/items/${id}`);
// Backend accepts item create/update both as POST (create has no :id in the
// path, update does) - matches this app's existing "POST does create-or-update"
// idiom (e.g. campaigns), so no new apicall.patch helper is needed.
export const createItem = (data) => apicall.post(data, "inventory/items");
export const updateItem = (id, data) => apicall.post(data, `inventory/items/${id}`);
export const deactivateItem = (id) => apicall.del(`inventory/items/${id}`);
export const getLowStockItems = () => apicall.get("inventory/items/low-stock");
export const getItemHistory = (id, params = {}) => apicall.get(`inventory/items/${id}/history${qs(params)}`);
export const exportItemHistoryPdf = (id, htmlContent) =>
  apicall.generate_pdf({ htmlContent }, `inventory/items/${id}/history/export-pdf`);

export const getCategories = (filters = {}) => apicall.get(`inventory/categories${qs(filters)}`);
export const createCategory = (name) => apicall.post({ name }, "inventory/categories");
export const updateCategory = (id, data) => apicall.post(data, `inventory/categories/${id}`);
export const deactivateCategory = (id) => apicall.del(`inventory/categories/${id}`);

/* ---------------------------------------------------------------- *
 *  Stock transactions (stock-in / adjust / return / wastage)
 * ---------------------------------------------------------------- */
export const postTransaction = (data) => apicall.post(data, "inventory/transactions");

/* ---------------------------------------------------------------- *
 *  Settings
 * ---------------------------------------------------------------- */
export const getSettings = () => apicall.get("inventory/settings");
export const updateSettings = (data) => apicall.post(data, "inventory/settings");

/* ---------------------------------------------------------------- *
 *  Dashboard widget
 * ---------------------------------------------------------------- */
export const getDashboardWidget = () => apicall.get("inventory/dashboard-widget");

/* ---------------------------------------------------------------- *
 *  Analytics
 * ---------------------------------------------------------------- */
export const getUsageOverTime = (params = {}) => apicall.get(`inventory/analytics/usage${qs(params)}`);
export const getTopUsedItems = (params = {}) => apicall.get(`inventory/analytics/top-items${qs(params)}`);
export const getUsageByCategory = (params = {}) => apicall.get(`inventory/analytics/usage-by-category${qs(params)}`);
export const getUsageByServiceType = (params = {}) =>
  apicall.get(`inventory/analytics/usage-by-service-type${qs(params)}`);
export const getValuation = () => apicall.get("inventory/analytics/valuation");
export const getMargin = (params = {}) => apicall.get(`inventory/analytics/margin${qs(params)}`);
export const getSlowDeadStock = (params = {}) => apicall.get(`inventory/analytics/slow-dead-stock${qs(params)}`);

/* ---------------------------------------------------------------- *
 *  Reports (export-capable)
 * ---------------------------------------------------------------- */
export const getReport = (reportKey, params = {}) => apicall.get(`inventory/reports/${reportKey}${qs(params)}`);
export const exportReportPdf = (reportKey, htmlContent) =>
  apicall.generate_pdf({ htmlContent }, `inventory/reports/${reportKey}/export-pdf`);

/* ---------------------------------------------------------------- *
 *  Booking "Parts Used"
 * ---------------------------------------------------------------- */
export const getBookingParts = (bookingId) => apicall.get(`bookings/${bookingId}/parts`);
export const addBookingPart = (bookingId, data) => apicall.post(data, `bookings/${bookingId}/parts`);
export const updateBookingPart = (bookingId, partId, data) =>
  apicall.post(data, `bookings/${bookingId}/parts/${partId}`);
export const deleteBookingPart = (bookingId, partId) => apicall.del(`bookings/${bookingId}/parts/${partId}`);
